module.exports = __webpack_public_path__ + "img/Hawaiian Poke-Tofu.cabb2327.jpg";